var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing;
  return {
    metricGroupPaddingTop: spacing.medium,
    cardTopMargin: spacing.small,
    cardBottomMargin: spacing.medium,
    viewPaddingRight: spacing.medium,
    viewPaddingRightAdjust: spacing.xxSmall,
    viewPaddingTop: spacing.medium,
    headingPadding: spacing.medium,
    cardWrapperPadding: spacing.medium,
    metricsColumnGap: '82px'
  };
};
export default generateComponentTheme;